import {
  PLPPhotoPreviewAction,
  UPDATE_PLP_PHOTO_PREVIEW_STATE,
} from 'cards/actions/plpPhotoPreview';

export interface PLPPhotoPreviewState {
  cardType: string | null;
  uploadcareFile: any | null;
}

const initialState: PLPPhotoPreviewState = {
  cardType: null,
  uploadcareFile: null,
};

const plpPhotoPreviewReducer = (
  state = initialState,
  action: PLPPhotoPreviewAction
): PLPPhotoPreviewState => {
  switch (action.type) {
    case UPDATE_PLP_PHOTO_PREVIEW_STATE: {
      return { ...state, ...(action.payload || {}) };
    }
    default: {
      return state;
    }
  }

  return state;
};

export default plpPhotoPreviewReducer;
